import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeFabricatorSettingsView.';

  public static readonly fabricatorSettings = `${Id.prefix}fabricatorSettings`;
  public static readonly optimizerSettings = `${Id.prefix}optimizerSettings`;
  public static readonly kerf = `${Id.prefix}kerf`;
  public static readonly kerfAngle = `${Id.prefix}kerfAngle`;
  public static readonly fabricatorSettingsSaved = `${Id.prefix}fabricatorSettingsSaved`;
  public static readonly invalidMeasurementFormat = `${Id.prefix}invalidMeasurementFormat`;
  public static readonly supplierOffline = `${Id.prefix}supplierOffline`;
  public static readonly measurementParsingUnsupported = `${Id.prefix}measurementParsingUnsupported`;
}

export class LangFranchiseeFabricatorSettingsView {
  private constructor() {}

  public static fabricatorSettings(): string {
    return interpolate(Id.fabricatorSettings);
  }
  public static optimizerSettings(): string {
    return interpolate(Id.optimizerSettings);
  }
  public static kerf(): string {
    return interpolate(Id.kerf);
  }
  public static kerfAngle(): string {
    return interpolate(Id.kerfAngle);
  }
  public static fabricatorSettingsSaved(): string {
    return interpolate(Id.fabricatorSettingsSaved);
  }
  public static invalidMeasurementFormat(): string {
    return interpolate(Id.invalidMeasurementFormat);
  }
  public static supplierOffline(): string {
    return interpolate(Id.supplierOffline);
  }
  public static measurementParsingUnsupported(): string {
    return interpolate(Id.measurementParsingUnsupported);
  }
}

export class FranchiseeFabricatorSettingsViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.fabricatorSettings, 'Fabricator Settings', 'Tab caption for fabricator settings');
    register.add(Id.optimizerSettings, 'Optimizer Settings', 'Section header for optimizer settings');
    register.add(Id.kerf, 'Kerf', 'Label for kerf input field');
    register.add(Id.kerfAngle, 'Angled Kerf', 'Label for angled kerf input field');
    register.add(
      Id.fabricatorSettingsSaved,
      'Fabricator settings saved',
      'Toast message for fabricator settings saved'
    );
    register.add(
      Id.invalidMeasurementFormat,
      'Invalid measurement format',
      'Error message for invalid measurement input'
    );
    register.add(
      Id.supplierOffline,
      'Supplier is offline. Cannot validate measurement.',
      'Error when supplier V6 instance is not available'
    );
    register.add(
      Id.measurementParsingUnsupported,
      'This supplier needs a newer V6 version to validate measurements.',
      'Error when the loaded frame config is older than the measurement parsing exposure (hasMeasurementParsing)'
    );
  }
}
